import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withLanguage from './withLanguage';
import t from './getTranslation';

class TranslatedText extends Component {
    render() {
        const { lang, transKey } = this.props;

        return (
            <span>{t(lang, transKey)}</span>
        );
    }
}

TranslatedText.propTypes = {
    transKey: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
};
TranslatedText.defaultProps = {};

export default withLanguage(TranslatedText);



// WEBPACK FOOTER //
// ./src/translations/TranslatedText.js